import { useTranslation } from 'react-i18n-lite'

import { View, Text } from '@react-pdf/renderer'

import { PDFInformationalInput } from '@yes.technology/react-toolkit'

import FilterGroupChip from '../FilterGroupChip/FilterGroupChip'

import getStyles from './styles'

interface FilterHeadProps {
  isSingleGroup: boolean
  filteractionName?: string
  composition: string
}

const MATCHING_RGX = /([0-9]+)/g

function FilterHead({ filteractionName, composition }: FilterHeadProps) {
  const { t } = useTranslation()

  const styles = getStyles()

  const texts = composition
    .split(MATCHING_RGX)
    .map((subgroup) => subgroup.trim())

  const translateOperator = (text: string) =>
    text.replace(/\b(AND|OR)\b/gi, (match) =>
      match === 'AND'
        ? t('composition-operator.and')
        : t('composition-operator.or')
    )

  const alternatingTextLabel = () =>
    texts.map((text, index) =>
      index % 2 === 0 ? (
        <Text style={styles.spacingFilterGroup} key={text + index}>
          {translateOperator(text.toUpperCase())}
        </Text>
      ) : (
        <FilterGroupChip
          key={text + index}
          text={`${t('report.filter-area.filter-head.filter-group')} ${text}`}
          style={styles.spacingFilterGroup}
        />
      )
    )

  return (
    <View style={styles.mainContainer}>
      {filteractionName && (
        <View style={styles.firstItem}>
          <PDFInformationalInput
            heightClass='extraSmall'
            label={t('report.filter-area.filter-head.filter-action')}
            value={filteractionName}
          />
        </View>
      )}

      <View style={styles.midItem}>
        <View style={styles.compositionField}>
          <Text style={styles.compositionLabel}>
            {t('report.filter-area.filter-head.filter-action-composition')}
          </Text>
          <View style={styles.compositionGroupContent}>
            {texts.length === 1 ? (
              <FilterGroupChip
                text={`${t('report.filter-area.filter-head.filter-group')} 1`}
                style={styles.spacingFilterGroup}
              />
            ) : (
              alternatingTextLabel()
            )}
          </View>
        </View>
      </View>
    </View>
  )
}

export default FilterHead
